import React__default, { useMemo } from 'react';
import { useIntl } from '@grandvisionhq/state';
import SuccessMessage from './SuccessMessage.js';

const SuccessMessageContainer = ()=>{
    const { getLabel , locale  } = useIntl();
    const messageLabels = useMemo(()=>({
            title: getLabel('customersupport.success.title'),
            content: getLabel('customersupport.success.content')
        })
    , [
        locale
    ]);
    return /*#__PURE__*/ React__default.createElement(SuccessMessage, {
        labels: messageLabels
    });
};
var SuccessMessageContainer$1 = SuccessMessageContainer;

export { SuccessMessageContainer$1 as default };
//# sourceMappingURL=SuccessMessageContainer.js.map
